import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import AppPc from "@/components/AppComp/index.vue";
import AppMobile from "@/components/AppComp/mobile.vue";
import audioBg from "@/assets/audio/bg.mp3";
import "@/utils/hall/hall";
import { mapStore } from "@/store/map";

import { ref, computed, provide, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
export default {
  __name: 'App',
  setup(__props) {
    const isMobile = ref(false);
    const {
      byname,
      level
    } = mapStore();
    const Route = useRoute();
    const Router = useRouter();
    const title = computed(() => {
      if (Route.path === "/beauty") {
        return "大美" + byname.value;
      } else if (Route.path === "/investment" && level.value !== 1) {
        return "招商赣线 " + byname.value;
      } else {
        return Route?.meta?.subtitle || Route.meta.title;
      }
    });

    /* 👇 背景音乐 👇 */
    const audioIns = ref(null);
    function initAudio() {
      audioIns.value = new Audio("https://zsgx.ncscloudmedia.com/bg.mp3");
      audioIns.value.loop = true; // 设置循环播放
      audioIns.value.play().catch(err => {
        // console.log("autplay-err", err);
        ElMessageBox.confirm("是否播放背景音乐？", "温馨提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
          appendTo: ".home"
        }).then(() => {
          audioIns.value.play();
        }).catch(() => {});
      });
    }
    provide("useAudio", {
      audioIns
    });
    /* 👆 背景音乐 👆 */

    const onCoyp = () => {
      window.open("https://beian.miit.gov.cn", "_blank");
    };
    provide("app-store", {
      title,
      onCoyp
    });
    provide("global-store", {
      isMobile
    });
    onMounted(() => {
      isMobile.value = Route?.query?.end === "mobile" || document.documentElement.clientWidth <= 1080;
      // 音频初始化
      // initAudio();
      document.body.addEventListener("plugin_web_update_notice", e => {
        window.location.reload();
      });
    });
    return (_ctx, _cache) => {
      return _unref(isMobile) ? (_openBlock(), _createBlock(AppMobile, {
        key: 0
      })) : (_openBlock(), _createBlock(AppPc, {
        key: 1
      }));
    };
  }
};